import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/me.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/github_icon.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a target="__blank" href="https://www.linkedin.com/in/samuelonwodi/"><img src={navIcon1} alt="Icon" /></a>
              <a  target="__blank" href="https://github.com/Onwodis"><img src={navIcon2} alt="Icon" /></a>
              <a  target="__blank" href="https://instagram.com/samuelonwodifullstack"><img src={navIcon3} alt="Icon" /></a>
          
            </div>
            <p>Copyright {new Date().getFullYear()}. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
